import uuid from "react-uuid"
import { AssessmentStarterSystemMessagge, Assessments, Assessments_IDs, ChatMessage, Conversation, FlowType, MessageType } from "../api"

export const delay = (ms: number) => new Promise(res => setTimeout(res, ms));

export const isASsessmentQuestion = (str: string): boolean => {
    return str.startsWith("{") && str.endsWith("}");
};

export const askAssessmentQuestion = (question: string): ChatMessage[] => [
    {
        id: uuid(),
        role: "assistant",
        content: question,
        date: new Date().toISOString(),
        flowtype: FlowType.AssessmentQuestion,
        messageType: MessageType.Text,
    },

]

export const askForConsultationMessage: ChatMessage[] = [
    {
        id: uuid(),
        role: "assistant",
        content: "Do you want to book a consultation?",
        date: new Date().toISOString(),
        flowtype: FlowType.Chat,
        messageType: MessageType.Text,
    },
    {
        id: uuid(),
        role: "user",
        content: '',
        date: new Date().toISOString(),
        flowtype: FlowType.ConversationStarter,
        messageType: MessageType.Options,
        messageInfo: {
            options: [
                {
                    label: "Book Consultation",
                    value: "open form",
                },
                {
                    label: "Resolve another IT Challenge",
                    value: "Resolve another IT Challenge",
                },
                {
                    label: "Assess Security 🔒",
                    value: "Assess Security 🔒",
                }
            ]
        }
    }
]

export const askForConsultationAssessmentMessage: ChatMessage[] = [
    {
        id: uuid(),
        role: "assistant",
        content: "I recommend to connect with a New Scaler expert subject matter expert. Do you want to book a consultation?",
        date: new Date().toISOString(),
        flowtype: FlowType.Chat,
        messageType: MessageType.Text,
    },
    {
        id: uuid(),
        role: "user",
        content: '',
        date: new Date().toISOString(),
        flowtype: FlowType.ConversationStarter,
        messageType: MessageType.Options,
        messageInfo: {
            options: [{
                label: "Book Consultation",
                value: "open form",
            },
            {
                label: "Assess another area",
                value: "Assess another area",
            }]
        }
    }
]


export const submitFormResponseMessage: ChatMessage[] = [
    {
        id: uuid(),
        role: "assistant",
        content: "Thank you for submitting the form, our subject matter expert will be in touch with you shortly!",
        date: new Date().toISOString(),
        flowtype: FlowType.ConversationStarter,
        messageType: MessageType.Text,
    },
    {
        id: uuid(),
        role: "assistant",
        content: "Need help with anything else?",
        date: new Date().toISOString(),
        flowtype: FlowType.ConversationStarter,
        messageType: MessageType.Text,
    },
    {
        id: uuid(),
        role: "user",
        content: "",
        date: new Date().toISOString(),
        flowtype: FlowType.ConversationStarter,
        messageType: MessageType.Options,
        messageInfo: {
            options: [
                {
                    label: "Resolve IT Challenges 💡",
                    value: "Resolve IT Challenges 💡",
                },
                {
                    label: "Assess Security 🔒",
                    value: "Assess Security 🔒",
                }
            ]
        }
    }
]

export const askForEmailMessage: ChatMessage[] = [
    {
        id: uuid(),
        role: "assistant",
        content: "In case we get disconnected, what is your email?",
        date: new Date().toISOString(),
        flowtype: FlowType.AskForEmail,
        messageType: MessageType.Text,
    },
]
export const initialMessages: ChatMessage[] = [
    {
        id: uuid(),
        role: "assistant",
        content: `Welcome to New Scaler! 👋
        Curious to discover how we boost your IT efficiency & effectiveness?
        \nPlease Select an Option`,
        date: new Date().toISOString(),
        flowtype: FlowType.ConversationStarter,
        messageType: MessageType.Text,
    },
    {
        id: uuid(),
        role: "user",
        content: "",
        date: new Date().toISOString(),
        flowtype: FlowType.ConversationStarter,
        messageType: MessageType.Options,
        messageInfo: {
            options: [
                {
                    label: "Discover How we can help!",
                    value: "Discover How we can help!",
                },
            ]
        }
    }
]

export const discoverHowWeCanHelpMessages: ChatMessage[] = [{
    id: uuid(),
    role: "assistant",
    content: `At New Scaler, we drive business growth by optimising people, processes & tech, ushering in the Era of AI.
    \nOur Pulse platform offers tailored IT solutions for your key challenges. What's next for you?
    \nWhat would you like to do today?`,
    date: new Date().toISOString(),
    flowtype: FlowType.ConversationStarter,
    messageType: MessageType.Text,
},
{
    id: uuid(),
    role: "user",
    content: "",
    date: new Date().toISOString(),
    flowtype: FlowType.ConversationStarter,
    messageType: MessageType.Options,
    messageInfo: {
        options: [
            {
                label: "Resolve IT Challenges 💡",
                value: "Resolve IT Challenges 💡",
            },
            {
                label: "Assess Security 🔒",
                value: "Assess Security 🔒",
            }
        ]
    }
}]

export const askAreasToAssess: ChatMessage[] = [
    {
        id: uuid(),
        role: "assistant",
        content: `What areas you looking to assess today?`,
        date: new Date().toISOString(),
        flowtype: FlowType.ConversationStarter,
        messageType: MessageType.Text,
    },
    {
        id: uuid(),
        role: "user",
        content: ``,
        date: new Date().toISOString(),
        flowtype: FlowType.ConversationStarter,
        messageType: MessageType.Options,
        messageInfo: {
            options: [
                {
                    label: Assessments.Identity_Security,
                    value: Assessments_IDs.Identity_Security,
                    flowtype: FlowType.IdentityAssessment,
                },
                {
                    label: Assessments.Data_Security,
                    value: Assessments_IDs.Data_Security,
                    flowtype: FlowType.DataAssessment,
                },
                {
                    label: Assessments.AI_Readiness,
                    value: Assessments_IDs.AI_Readiness,
                    flowtype: FlowType.AIAssessment,
                },

            ]
        }

    },
]
export const askMoreDetailMessage: ChatMessage[] = [{
    id: uuid(),
    role: "assistant",
    content: `Could you please provide more details about the issue you're experiencing, so we can assist you more effectively?`,
    date: new Date().toISOString(),
    flowtype: FlowType.ConversationStarter,
    messageType: MessageType.Text,
},
]

export const resolveITMessages: ChatMessage[] = [{
    id: uuid(),
    role: "assistant",
    content: `What business technology problem can New Scaler help you with?`,
    date: new Date().toISOString(),
    flowtype: FlowType.ConversationStarter,
    messageType: MessageType.Text,
},
]

export const consultationFormMessages: ChatMessage[] = [
    {
        id: uuid(),
        role: "assistant",
        content: `Please help me with the information below`,
        date: new Date().toISOString(),
        flowtype: FlowType.ConversationStarter,
        messageType: MessageType.Text,
    },
    {
        id: uuid(),
        role: "user",
        content: ``,
        date: new Date().toISOString(),
        flowtype: FlowType.ConversationStarter,
        messageType: MessageType.ConsultationForm,
    },
]

export const afterSelectingAssessment = (type: Assessments): ChatMessage[] => {

    let assistantContent = '', userFlowtype = FlowType.ConversationStarter;
    if (type === Assessments.Identity_Security) {
        assistantContent = AssessmentStarterSystemMessagge.IdentityAssessmentSystemStarter;
        userFlowtype = FlowType.IdentityAssessment
    } else if (type === Assessments.Data_Security) {
        assistantContent = AssessmentStarterSystemMessagge.DataAssessmentSystemStarter;
        userFlowtype = FlowType.DataAssessment
    } else if (type === Assessments.AI_Readiness) {
        assistantContent = AssessmentStarterSystemMessagge.AIAssessmentSystemStarter;
        userFlowtype = FlowType.AIAssessment
    }
    return [
        {
            id: uuid(),
            role: "assistant",
            content: assistantContent,
            date: new Date().toISOString(),
            flowtype: FlowType.ConversationStarter,
            messageType: MessageType.Text,
        },
        {
            id: uuid(),
            role: "user",
            content: '',
            date: new Date().toISOString(),
            flowtype: userFlowtype,
            messageType: MessageType.Options,
            messageInfo: {
                options: [
                    {
                        label: "Yes, I am ready to begin",
                        value: "Yes, I am ready to begin",
                    },
                ]
            }
        },
    ]
}

export const getNewResponseAndFilter = (conversation: Conversation, content: string, followMessage: ChatMessage[]): Conversation => {
    const userResponse: ChatMessage = {
        id: uuid(),
        role: "user",
        content,
        date: new Date().toISOString(),
        flowtype: FlowType.ConversationStarter,
        messageType: MessageType.Text,
    };
    const newMessages = conversation.messages.filter((answer: ChatMessage) => answer.messageType !== MessageType.Options);

    const updatedConversation: Conversation = {
        id: conversation.id || uuid(),
        messages: [...newMessages, userResponse, ...followMessage],
        title: conversation.title || "Welcome to New Scaler",
        date: conversation.date || new Date().toISOString(),
    };

    return updatedConversation;
}

export const getFormatMessage = (assessmentConversation: string[]): string => {
    let finalRequestMsg = "{"
    for (let index = 0; index < assessmentConversation?.length; index++) {
        const element = assessmentConversation[index];
        if (element.indexOf("ASSISTANT:") > -1 && index != 0) finalRequestMsg += "};{"
        finalRequestMsg += element;
    }
    finalRequestMsg += '}';
    return finalRequestMsg
}

export const idToTextObj: any = {
    [Assessments_IDs.Identity_Security]: Assessments.Identity_Security,
    [Assessments_IDs.Data_Security]: Assessments.Data_Security,
    [Assessments_IDs.AI_Readiness]: Assessments.AI_Readiness,
}